import React from "react";

/**
 * Tiny pill that shows whether a card lives on the closed-loop wallet
 * or has been provisioned on a real card network (Stripe Issuing today).
 *
 * Usage:
 *   <IssuanceSourceBadge provider={card.provider} network={card.network} />
 *
 * `provider` values:
 *   "stripe" | "nium" | "wise" → network-backed (gold + brand label)
 *   "mock"  | undefined        → closed-loop wallet (subtle slate)
 */
export function IssuanceSourceBadge({ provider, network, size = "sm" }) {
  const isNetwork = provider && provider !== "mock" && provider !== "wallet";
  const sizeClass = size === "xs" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-0.5";

  if (isNetwork) {
    const label =
      provider === "stripe"
        ? `${(network || "visa").toUpperCase()} · STRIPE`
        : provider.toUpperCase();
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full font-medium tracking-wider uppercase border border-[#CBA35C]/40 bg-[#CBA35C]/10 text-[#8C6B21] ${sizeClass}`}
        data-testid="issuance-source-badge-network"
        title="Provisioned on a real card network"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[#CBA35C]" aria-hidden="true" />
        {label}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium tracking-wider uppercase border border-[#E5E0D8] bg-[#FBF9F6] text-[#7A8B82] ${sizeClass}`}
      data-testid="issuance-source-badge-wallet"
      title="Closed-loop Zcardon wallet — receivers spend via QR"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#7A8B82]" aria-hidden="true" />
      Wallet
    </span>
  );
}

export default IssuanceSourceBadge;
